var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.inputs, function (inp, idx) {
        return _c("div", { key: idx, staticClass: "row mb-2" }, [
          _c("div", { staticClass: "col-10 col-lg-6" }, [
            _c("div", { staticClass: "holder" }, [
              _vm.type === "checkbox"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputs[idx],
                        expression: "inputs[idx]",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: _vm.id,
                      "aria-labelledby": _vm.id + "_label",
                      maxlength: _vm.maxlength,
                      autocomplete: _vm.autocomplete,
                      readonly: _vm.readonly,
                      step: _vm.type == "number" ? 1 : null,
                      pattern: _vm.type == "number" ? "[0-9]*" : null,
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.inputs[idx])
                        ? _vm._i(_vm.inputs[idx], null) > -1
                        : _vm.inputs[idx],
                    },
                    on: {
                      input: _vm.emmitEvent,
                      keydown: _vm.emitKeydown,
                      change: [
                        function ($event) {
                          var $$a = _vm.inputs[idx],
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.inputs, idx, $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.inputs,
                                  idx,
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.inputs, idx, $$c)
                          }
                        },
                        _vm.emitChange,
                      ],
                    },
                  })
                : _vm.type === "radio"
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputs[idx],
                        expression: "inputs[idx]",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: _vm.id,
                      "aria-labelledby": _vm.id + "_label",
                      maxlength: _vm.maxlength,
                      autocomplete: _vm.autocomplete,
                      readonly: _vm.readonly,
                      step: _vm.type == "number" ? 1 : null,
                      pattern: _vm.type == "number" ? "[0-9]*" : null,
                      type: "radio",
                    },
                    domProps: { checked: _vm._q(_vm.inputs[idx], null) },
                    on: {
                      input: _vm.emmitEvent,
                      keydown: _vm.emitKeydown,
                      change: [
                        function ($event) {
                          return _vm.$set(_vm.inputs, idx, null)
                        },
                        _vm.emitChange,
                      ],
                    },
                  })
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputs[idx],
                        expression: "inputs[idx]",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: _vm.id,
                      "aria-labelledby": _vm.id + "_label",
                      maxlength: _vm.maxlength,
                      autocomplete: _vm.autocomplete,
                      readonly: _vm.readonly,
                      step: _vm.type == "number" ? 1 : null,
                      pattern: _vm.type == "number" ? "[0-9]*" : null,
                      type: _vm.type,
                    },
                    domProps: { value: _vm.inputs[idx] },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.inputs, idx, $event.target.value)
                        },
                        _vm.emmitEvent,
                      ],
                      keydown: _vm.emitKeydown,
                      change: _vm.emitChange,
                    },
                  }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-2 col-lg-2" }, [
            _vm.inputs.length > 1
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    on: {
                      click: function ($event) {
                        return _vm.del(idx)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "bi bi-x-circle-fill" }),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(" " + _vm._s(_vm.$t("usun_wiersz"))),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ])
      }),
      _vm._v(" "),
      !_vm.maxinputs || _vm.maxinputs > _vm.inputs.length
        ? _c(
            "button",
            {
              staticClass: "btn btn-success",
              on: {
                click: function ($event) {
                  return _vm.add()
                },
              },
            },
            [
              _c("i", { staticClass: "bi bi-plus-circle" }),
              _vm._v(" " + _vm._s(_vm.$t("dodaj"))),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }